import { render, staticRenderFns } from "./ModifyTable.vue?vue&type=template&id=f3b4fb40&scoped=true&"
import script from "./ModifyTable.vue?vue&type=script&lang=js&"
export * from "./ModifyTable.vue?vue&type=script&lang=js&"
import style0 from "./ModifyTable.vue?vue&type=style&index=0&id=f3b4fb40&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b4fb40",
  null
  
)

export default component.exports